import type { FC } from 'react';

import { uiConfig } from '@/config';
import { AlertMessage } from '@/ui-kit';

type FieldDeclarationAlertProps = {
  message: string;
};

/** A field's standing declaration, spanning the group's grid row. */
export const FieldDeclarationAlert: FC<FieldDeclarationAlertProps> = ({ message }) => (
  <div className={uiConfig.grid.maxColumnsSpanClass}>
    <AlertMessage
      className="alert-message-full-width"
      variant="color"
      description={message}
      role="status"
    />
  </div>
);
